import Vue from "vue";
import Vuex from "vuex";
import jwtDecode from "jwt-decode";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    authorized: false,
    user: {},
    listsNames: {
      clients: "Клиенты",
      users: "Пользователи",
      providers: "Провайдеры",
      cashboxes: "Кассы",
      series: "Серии",
      statuses: "Статусы",
    },
    lists: {
      clients: [],
      users: [],
      providers: [],
      cashboxes: [],
      series: [],
      statuses: [],
      sno: [
        { id: "osn", title: "Общая" },
        { id: "usn_income", title: "Упрощенная: Доходы" },
        { id: "usn_income_outcome", title: "Упрощенная: Доходы - Расходы" },
        { id: "envd", title: "Единый налог на вмененный доход" },
        { id: "esn", title: "Единый сельскохозяйственный налог" },
        { id: "patent", title: "Патентная" },
      ],
      userTypes: [
        { id: 1, title: "Гость" },
        { id: 2, title: "Пользователь" },
        { id: 3, title: "Администратор" },
        { id: 4, title: "Супер-администратор" },
      ],
      vat: [
        { id: "none", title: "без НДС" },
        { id: "vat0", title: "НДС по ставке 0%" },
        { id: "vat10", title: "НДС чека по ставке 10%" },
        { id: "vat18", title: "НДС чека по ставке 18%" },
        { id: "vat110", title: "НДС чека по расчетной ставке 10/110" },
        { id: "vat118", title: "НДС чека по расчетной ставке 18/118" },
        { id: "vat20", title: "НДС чека по ставке 20%" },
        { id: "vat120", title: "НДС чека по расчетной ставке 20/120" },
      ],
      paymentTypes: [
        { id: "cash", title: "Наличный" },
        { id: "nocash", title: "Безналичный" },
      ],
    },
    dictsNames: {
      transports: "Транспорт",
      routes: "Маршруты",
      rolls: "Катушки",
    },
    dicts: {
      transports: [],
      rolls: [],
      routes: [],
      series: [],
      transportTypes: [
        { id: "bus", title: "Автобус" },
        { id: "mt", title: "Маршрутное такси" },
      ],
    },
    cruds: {
      clients: {
        id: { title: "ID", width: 50, readonly: true },
        title: { title: "Название", width: 0, type: "text" },
        vat: { title: "VAT", width: 80, hidden: true, type: "list", list: "vat" },
        sno: { title: "СНО", width: 120, hidden: true, type: "list", list: "sno" },
        phone: { title: "Телефон", width: 120, type: "text" },
        email: { title: "Email", width: 160, type: "text" },
        inn: { title: "ИНН", width: 120, type: "text" },
        payment_address: { title: "Сайт", width: 0, type: "text", hidden: true },
        max_tickets: { title: "Лимит", width: 60, type: "number" },
        is_disabled: { title: "Выключен", hidden: true, type: "checkbox" },
      },
      users: {
        id: { title: "ID", width: 50, readonly: true },
        id_clients: { title: "Клиент", type: "list", list: "clients" },
        title: { title: "Имя", width: 0, type: "text" },
        login: { title: "Логин", width: 120, type: "text" },
        password: { title: "Пароль", hidden: true, type: "text" },
        id_user_types: { title: "Тип", width: 160, type: "list", list: "userTypes" },
        is_disabled: { title: "Выключен", hidden: true, type: "checkbox" },
      },
      providers: {
        id: { title: "ID", width: 50, readonly: true },
        title: { title: "Название", width: 0, type: "text" },
        api_url: { title: "URL", width: 0, type: "text" },
      },
      cashboxes: {
        id: { title: "ID", width: 50, readonly: true },
        id_clients: { title: "Клиент", type: "list", list: "clients" },
        login: { title: "Логин", width: 0, type: "text" },
        password: { title: "Пароль", width: 0, type: "text" },
        token: { title: "Токен", hidden: true, readonly: true },
        id_providers: { title: "Провайдер", type: "list", list: "providers" },
      },
      series: {
        id: { title: "ID", width: 50, readonly: true },
        number: { title: "Номер", width: 0, type: "text" },
        price: { title: "Цена", width: 0, type: "text" },
        id_clients: { title: "Клиент", type: "list", list: "clients" },
        payment_type: { title: "Расчет", width: 80, type: "list", list: "paymentTypes" },
        is_visible: { title: "Отображать", type: "checkbox" },
      },
      statuses: {
        id: { title: "ID", width: 50, readonly: true },
        title: { title: "Название", width: 0, type: "text" },
      },
    },
  },
  mutations: {
    updateUser(state, user) {
      Object.assign(state.user, user);
    },
    updateList(state, { title, list }) {
      state.lists[title].length = 0;
      list.forEach((e) => state.lists[title].push(e));
    },
    updateDict(state, { title, dict }) {
      state.dicts[title].length = 0;
      dict.forEach((e) => state.dicts[title].push(e));
    },
    authorized(state, value) {
      state.authorized = value;
    },
  },
  actions: {
    updateUser({ commit }) {
      const token = window.localStorage.getItem("token");
      if (token) {
        commit("updateUser", jwtDecode(token));
        commit("authorized", true);
      } else {
        commit("updateUser", {});
        commit("authorized", false);
      }
    },
    updateList({ commit }, { title, list }) {
      commit("updateList", { title, list });
    },
    updateDict({ commit }, { title, dict }) {
      commit("updateDict", { title, dict });
    },
  },
  modules: {},
});
